<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listaEventTasks"
        title-table="Tarefas de Evento"
        module="eventTaskSettingsModule"
        sort-name="titulo"
        add-permission="ROLE_EVENTOS_INSERIR"
        view-permission="ROLE_EVENTOS_CONSULTAR"
        edit-permission="ROLE_EVENTOS_ATUALIZAR"
        delete-permission="ROLE_EVENTOS_DELETAR"
        @add="addNew"
        @edit="edit"
      />
      <EventTaskForm
        v-else
        @cancelar="cancelar"
      />
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol } from 'bootstrap-vue'
import EventTaskForm from './form/EventTaskForm.vue'

export default {
  name: 'EventTaskSetting',
  components: {
    BRow,
    BCol,
    TableComponents,
    EventTaskForm,
  },
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: 'ID',
          field: 'id',
          width: '80px',
        },
        {
          label: 'Título',
          field: 'titulo',
        },
        {
          label: 'Evento',
          field: 'evento.nome',
        },
        {
          label: 'Responsável',
          field: 'responsavel.nome',
        },
        {
          label: 'Data Prevista',
          field: 'dataPrevista',
          formatter: value => (value ? new Date(value).toLocaleDateString('pt-BR') : '-'),
        },
        {
          label: 'Status',
          field: 'concluida',
          formatter: value => (value ? 'Concluída' : 'Pendente'),
          width: '120px',
        },
        {
          label: 'Ativo',
          field: 'ativo',
          formatter: value => (value ? 'Sim' : 'Não'),
          width: '80px',
        },
        {
          label: 'Action',
          field: 'action',
          width: '80px',
        },
      ],
    }
  },
  computed: {
    ...mapState('eventTaskSettingsModule', {
      listaEventTasks: state => state.listaEventTasks,
    }),
  },
  methods: {
    addNew() {
      this.$store.dispatch('eventTaskSettingsModule/reset')
      this.showForm = true
    },
    edit(data) {
      this.$store.dispatch('eventTaskSettingsModule/prepareToEdit', data)
      this.showForm = true
    },
    cancelar() {
      this.showForm = false
      this.$store.dispatch('eventTaskSettingsModule/reset')
    },
  },
}
</script>
